import(/* webpackMode: "eager", webpackExports: ["PageRenderer"] */ "/home/runner/work/mm-js/mm-js/applications/content/src/cms/legacy/PageRenderer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Content"] */ "/home/runner/work/mm-js/mm-js/applications/content/src/components/homepage/Content.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/mm-js/mm-js/design/ragnar-ui/src/box/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["Clickable"] */ "/home/runner/work/mm-js/mm-js/design/ragnar-ui/src/clickable/index.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/mm-js/mm-js/design/ragnar-ui/src/link/index.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/mm-js/mm-js/design/ragnar-ui/src/text/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/mm-js/mm-js/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/mm-js/mm-js/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/home/runner/work/mm-js/mm-js/packages/content-ui/src/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterSlim"] */ "/home/runner/work/mm-js/mm-js/packages/content-ui/src/components/Footer/FooterSlim.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ActionMenu"] */ "/home/runner/work/mm-js/mm-js/packages/content-ui/src/components/Header/ActionMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/runner/work/mm-js/mm-js/packages/content-ui/src/components/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderSlim"] */ "/home/runner/work/mm-js/mm-js/packages/content-ui/src/components/Header/HeaderSlim.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavLink"] */ "/home/runner/work/mm-js/mm-js/packages/content-ui/src/components/Header/NavLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["H1"] */ "/home/runner/work/mm-js/mm-js/packages/content-ui/src/components/Typography/H1.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/mm-js/mm-js/packages/user/src/ServerUserProvider.tsx");
